import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  checkboxOptionRoot: {
    padding: 0,
    gap: '1rem',
    alignItems: 'start',
  },
  checkboxOptionLabel: {
    width: '100%',
  },

  checkboxRoot: {
    padding: '1px',
    width: '1.5rem',
    height: '1.5rem',
    color: neutral[100],
    '& svg': {
      fontSize: '1.5rem',
    },
    '&:hover': {
      color: neutral[80],
    },
  },
});
